<template>
<div style="width: 100%">
	<v-subheader>{{$t('agencies.agencies')}}</v-subheader>
	<v-tooltip top slot="activator">
		<v-btn
			:loading="isLoadCrate"
			slot="activator"
			@click="addAgency"
			color="indigo lighten-3"
			dark
			fab
		>
			<v-icon>add</v-icon>
		</v-btn>
		<span>{{$t('agencies.add_agency')}}</span>
	</v-tooltip>
	<v-card style="width: 100%">
		<v-card-title>
			{{$t('agencies.agencies')}}
			<v-spacer />
			<v-text-field
				v-model="search"
				append-icon="search"
				:label="$t('workers.search')"
				single-line
				hide-details
			/>
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="agencies"
			:pagination.sync="pagination"
			:loading="loading"
			:total-items="totalItems"
			:rows-per-page-items="rowsPerPageItems"
		>
			<template slot="headers" slot-scope="props">
				<tr>
					<th
						v-for="header in props.headers"
						:key="header.text"
						:class="['table-head-column column sortable text-xs-' +
							(header.align ? header.align : 'left'),
							pagination.descending ? 'desc' : 'asc',
							header.value === pagination.sortBy ? 'active' : '']"
						@click="changeSort(header.value, header.sortable)"
					>
						<v-icon small v-if="header.sortable">arrow_upward</v-icon>
						{{ header.text }}
					</th>
				</tr>
			</template>
			<template slot="items" slot-scope="props">
				<td>{{ props.item.id }}</td>
				<td>{{ props.item.name }}</td>
				<td>{{ props.item.ico }}</td>
				<td>{{ props.item.dic }}</td>
				<td>{{ props.item.company_number }}</td>
				<td class="text-xs-right">
					<v-btn fab dark small color="indigo lighten-2" :to="'/agencies/' + props.item.id">
						<v-icon dark>edit</v-icon>
					</v-btn>
				</td>
			</template>
			<v-alert slot="no-results" :value="true" color="error" icon="warning">
				{{$t('common.no_result', {search})}}
			</v-alert>
		</v-data-table>
	</v-card>
</div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { HEADERS_TABLE_AGENCY, TEMPLATE_AGENCY } from '../constants'
import { localeHeadersAgency } from '../utils/helpers'

const { mapMutations, mapActions, mapState } = createNamespacedHelpers('agencies')

export default {
	data(vm) {
		return {
			search: '',
			pagination: {
				page: 1,
				rowsPerPage: 25,
				sortBy: 'id',
				descending: 'asc'
			},
			headers: localeHeadersAgency(HEADERS_TABLE_AGENCY, vm.$t),
			totalItems: 0,
			rowsPerPageItems: [25, 50, 100, 200]
		}
	},
	created() {
		this.search = this.$route.query.search
		this.pushQuery(this.$route.query)
	},
	computed: {
		...mapState(['agencies', 'isLoadCrate', 'loading', 'meta'])
	},
	destroyed() {
		this.setList({
			data: []
		})
	},
	methods: {
		...mapActions(['fetch', 'createAgency']),
		...mapMutations([
			'setList',
		]),
		addAgency() {
			this.createAgency({ ...TEMPLATE_AGENCY })
		},
		changeSort (column, sortable) {
			if(!sortable) {
				return
			}
			if (this.pagination.sortBy === column) {
				this.pagination.descending = !this.pagination.descending
			} else {
				this.pagination.sortBy = column
				this.pagination.descending = false
			}
		},
		updatePagination() {
			this.fetch(this.$route.query)
				.then(() => {
					this.totalItems = this.meta ? this.meta.total : null
				})
		},
		pushQuery (old_query = null) {
			let query = {
				count: this.pagination.rowsPerPage.toString(),
				offset: (this.pagination.rowsPerPage * (this.pagination.page - 1)).toString(),
				sortBy: this.pagination.sortBy,
				descending: this.pagination.descending ? 'asc' : 'desc'
			}
			this.search ? query.search = this.search.toLowerCase() : '',
			this.$router.push({ query: query })
			if(JSON.stringify(old_query) == JSON.stringify(query)) {
				this.updatePagination()
			}
		}
	},
	watch: {
		'pagination.page' () {
			this.pushQuery()
		},
		'pagination.rowsPerPage' () {
			this.pushQuery()
		},
		'pagination.descending' () {
			this.pushQuery()
		},
		'$route.query'() {
			this.updatePagination()
		},
		search () {
			this.pushQuery()
		}
	}
}
</script>
